import React from "react";
import { FormattedMessage } from "react-intl";
import compose from "recompose/compose";
import branch from "recompose/branch";
import withHandlers from "recompose/withHandlers";
import withProductWishlistMutations from "./withProductWishlistMutations";
import withEnsureLoggedIn from "theme/modules/User/helpers/withEnsureLoggedIn";
import withIsWishlistEnabled from "../withIsWishlistEnabled";
import withIsProductInWishlist from "./withIsProductInWishlist";
import branchServerClient from "web/core/branchServerClient";

export default () =>
  compose(
    branchServerClient(
      (BaseComponent) => BaseComponent,
      withIsProductInWishlist()
    ),
    withIsWishlistEnabled(),
    branch(
      (props) => props.wishlist.isFeatureActive,
      (BaseComponent) => BaseComponent,
      () => () => null
    ),
    withEnsureLoggedIn({
      message: (
        <FormattedMessage
          id="modules.Wishlist.AddProductToWishlist.needLogin"
          defaultMessage="You must log in before adding a product to your wishlist."
        />
      ),
    }),
    withHandlers({
      onAddDone: (props) => () => {
        props.reloadIfNewLogin();
        typeof props.onAddDone === "function" && props.onAddDone();
      },
    }),
    withHandlers({
      onSuccess: (props) => () => props.onAddDone(),
      onError: (props) => () => props.onAddDone(),
    }),
    withProductWishlistMutations()
  );
